import React, { useMemo } from 'react'
import { ArbeitsorgOrganisationType } from '@myapp/contract'
import PageLayout from '../../../shared/ui/layouts/PageLayout/PageLayout'
import { FormSection } from '../../../shared/ui'
import { useArbeitszeitReportFilters } from '../../../features/arbeitszeit-report/filters'
import { ArbeitszeitReportFilterBar } from './ui/ArbeitszeitReportFilterBar'
import { GesamtuebersichtTable } from './ui/GesamtuebersichtTable'
import { AuslastungstabelleList } from './ui/AuslastungstabelleList'
import { AuftraegeList } from './ui/AuftraegeList'
import { ArbeitsorganisationList } from './ui/ArbeitsorganisationList'

const ZEITMANAGEMENT_TYPES = new Set<ArbeitsorgOrganisationType>([
  'SICK_LEAVE',
  'VACATION',
  'PERSONAL_LEAVE',
  'TRAINING',
])

export const ArbeitszeitReportPage: React.FC = () => {
  const {
    data,
    isLoading,
    isFetching,
    error,
    pageAuftraege,
    setPageAuftraege,
    pageAuslastung,
    setPageAuslastung,
    pageArbeitsorganisation,
    setPageArbeitsorganisation,
  } = useArbeitszeitReportFilters()

  const allArbeitsorg = data?.arbeitsorganisation.items ?? []

  const zeitmanagementItems = useMemo(
    () => allArbeitsorg.filter((r) => ZEITMANAGEMENT_TYPES.has(r.organisationType)),
    [allArbeitsorg],
  )

  const aufgabenItems = useMemo(
    () => allArbeitsorg.filter((r) => !ZEITMANAGEMENT_TYPES.has(r.organisationType)),
    [allArbeitsorg],
  )

  return (
    <PageLayout pageTitle="Arbeitszeit-Report">
      <div className="flex w-full flex-col gap-6">
        <ArbeitszeitReportFilterBar />
        <FormSection title="Gesamtübersicht" cardClassName="overflow-hidden p-0 !rounded-lg">
          <GesamtuebersichtTable
            rows={data?.gesamtuebersicht ?? []}
            isLoading={isLoading}
            isFetching={isFetching}
          />
        </FormSection>

        <FormSection title="Auslastungsübersicht" cardClassName="overflow-hidden p-0 !rounded-lg">
          <AuslastungstabelleList
            items={data?.auslastung.items ?? []}
            meta={data?.auslastung.meta}
            isLoading={isLoading}
            isFetching={isFetching}
            page={pageAuslastung}
            onPageChange={setPageAuslastung}
          />
        </FormSection>

        <FormSection title="Aufträge" cardClassName="overflow-hidden p-0 !rounded-lg">
          <AuftraegeList
            items={data?.auftraege.items ?? []}
            aggregates={data?.auftraege.aggregates}
            meta={data?.auftraege.meta}
            isLoading={isLoading}
            isFetching={isFetching}
            error={error}
            page={pageAuftraege}
            onPageChange={setPageAuftraege}
          />
        </FormSection>

        <FormSection title="Zeitmanagement" cardClassName="overflow-hidden p-0 !rounded-lg">
          <ArbeitsorganisationList
            items={zeitmanagementItems}
            meta={data?.arbeitsorganisation.meta}
            isLoading={isLoading}
            isFetching={isFetching}
            page={pageArbeitsorganisation}
            onPageChange={setPageArbeitsorganisation}
          />
        </FormSection>

        <FormSection title="Aufgaben" cardClassName="overflow-hidden p-0 !rounded-lg">
          <ArbeitsorganisationList
            items={aufgabenItems}
            meta={data?.arbeitsorganisation.meta}
            isLoading={isLoading}
            isFetching={isFetching}
            page={pageArbeitsorganisation}
            onPageChange={setPageArbeitsorganisation}
          />
        </FormSection>
      </div>
    </PageLayout>
  )
}
